<template>
    <div class="row">
        <card-projetos-cadastrados class="mt-4 col-12 col-md-3" />
        <card-empresas-cadastradas class="mt-4 col-12 col-md-3" />
        <card-liberacoes-pendentes class="mt-4 col-12 col-md-3" />
        <card-contratos class="mt-4 col-12 col-md-3" />
        
        
        <div class="mt-4 col-12 col-md-6">
            <b-card no-body style="height:100%">
                <div class="mt-1 d-flex align-items-center justify-content-between">
                    <h5>
                        Mapa de utilização
                    </h5>
                </div>
                <hr>
                <mapa-brasil/>
            </b-card>
        </div>
        
        <div class="col-12 col-md-6 ">
            <div class="row">
                <div class="mt-4 col-12 col-md-6">
                    <b-card no-body>
                        <div class="mt-1 d-flex align-items-center justify-content-between">
                            <h5>
                                Empresas por região
                            </h5>
                        </div>
                        <hr>
                        <empresas-regiao-admin/>
                    </b-card>
                </div>

                <div class="mt-4 col-12 col-md-6">
                    <b-card no-body>
                        <div class="mt-1 d-flex align-items-center justify-content-between">
                            <h5>
                                Usuarios por região
                            </h5>
                        </div>
                        <hr>
                        <usuarios-regiao-admin/>
                    </b-card>
                </div>

                <div class="mt-4 col-12">
                    <b-card no-body>
                        <div class="mt-1 d-flex align-items-center justify-content-between">
                            <h5>
                                Empresas por segmento
                            </h5>
                        </div>
                        <hr>
                        <pizza-admin ref="pizza"/>                    
                    </b-card>
                </div>

            </div>
        </div>
        <b-card no-body class="mt-4 col-12">
            <div class="mt-1 d-flex align-items-center justify-content-between">
                <h5>
                    Saldo à investir
                </h5>
            </div>
            <hr>
            <tabela-saldo-investir/>
        </b-card>
    </div>
</template>
<script>


import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";

import CardProjetosCadastrados from "./components/cards_admin/CardProjetosCadastrados.vue";
import CardEmpresasCadastradas from "./components/cards_admin/CardEmpresasCadastradas.vue";
import CardLiberacoesPendentes from "./components/cards_admin/CardLiberacoesPendentes.vue";
import CardContratos from "./components/cards_admin/CardContratos.vue";

import PizzaAdmin from "./components/PizzaAdmin.vue";
import EmpresasRegiaoAdmin from "./components/EmpresasRegiaoAdmin.vue";
import UsuariosRegiaoAdmin from "./components/UsuariosRegiaoAdmin.vue";
import TabelaSaldoInvestir from "./components/TabelaSaldoInvestir.vue";

import MapaBrasil from "./components/MapaBrasilAdmin.vue"

export default {
    components:{
        MapaBrasil,
        CardProjetosCadastrados,
        CardEmpresasCadastradas,
        CardLiberacoesPendentes,
        CardContratos,
        PizzaAdmin,
        EmpresasRegiaoAdmin,
        UsuariosRegiaoAdmin,
        TabelaSaldoInvestir
    },
    data: () => ({
        items:[],
        fields:[
            {
                key: "key",
                label: "Empresa proponente",
            },
            {
                key: "valor",
                label: "Saldo a investir",
            },
        ]
    }),
    mounted(){
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            {titulo : "Dashboard"}
        ]);
    },
}
</script>
<style>
    .card-img-absolute {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
    }

    #my-chart .charts-css.area {
  height: 200px;
  max-width: 300px;
  margin: 0 auto;
}

    /** remover no merge */

    .card {
        min-height: inherit !important;
    }
</style>